import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './CreateNewUser.module.css';
import masaLogo from '../Assets/MasaLogo.png';
import { signup } from '../api/authApi';

const CreateNewUser = () => {
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [userType, setUserType] = useState('worker');
  const [modalMessage, setModalMessage] = useState(null);

  const userTypes = ['admin', 'manager', 'worker', 'sales'];

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await signup(username, password, userType);
      setModalMessage({ type: 'success', text: 'User created successfully!' });
    } catch (error) {
      if (error.response && error.response.data && error.response.data.error) {
        setModalMessage({ type: 'error', text: error.response.data.error });
      } else {
        setModalMessage({ type: 'error', text: 'An error occurred. Please try again.' });
      }
    }
  };

  const handleCloseModal = () => {
    setModalMessage(null);
    if (modalMessage?.type === 'success') navigate('/factory-manager');
  };

  return (
    <main className={styles.createUserView}>
      <header className={styles.header}>
        <img
          src={masaLogo}
          alt="Masa Logo"
          className={styles.logo}
          loading="lazy"
        />
        <h1 className={styles.pageTitle}>Create New User</h1>
      </header>

      <div className={styles.formContainer}>
        <form className={styles.userForm} onSubmit={handleSubmit}>
          <h2 className={styles.formHeading}>User Details</h2>

          <label className={styles.formLabel}>Username:</label>
          <input
            className={styles.formInput}
            type="text"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
            placeholder="Enter username"
          />

          <label className={styles.formLabel}>Password:</label>
          <input
            className={styles.formInput}
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            placeholder="Enter password"
          />

          <label className={styles.formLabel}>User Type:</label>
          <select
            className={styles.formInput}
            value={userType}
            onChange={(e) => setUserType(e.target.value)}
          >
            {userTypes.map((type) => (
              <option key={type} value={type}>
                {type.charAt(0).toUpperCase() + type.slice(1)}
              </option>
            ))}
          </select>

          <div className={styles.buttonGroup}>
            <button type="submit" className={styles.submitButton}>Create User</button>
            <button type="button" className={styles.cancelButton} onClick={() => navigate(-1)}>
              Cancel
            </button>
          </div>
        </form>
      </div>

      {modalMessage && (
        <div className={styles.modalBackdrop}>
          <div className={styles.modalContent}>
            <h2>{modalMessage.type === 'success' ? 'Success' : 'Error'}</h2>
            <p>{modalMessage.text}</p>
            <button onClick={handleCloseModal} className={styles.modalCloseButton}>
              Close
            </button>
          </div>
        </div>
      )}
    </main>
  );
};

export default CreateNewUser;
